import React from 'react';
import * as helper from '../../../../Common/html-helper';
import classNames from 'classnames';
import styles from '../../../articleTileGrid/article-tile/details/tileDetails.scss';
import IconColors from '../../../../Assets/svg/icon_colors';
import IPfTileDetails from './pfTileDetails.d';
import { IL10N } from '../../../../Common/l10n-keys';

function VariantCount({ amount, l10n }: { amount: number; l10n: IL10N }) {
    return (
        <>
            {amount > 0 &&
                <div className={styles.d_colors}>
                    <span>
                        <span className={styles.c_icon}><IconColors/></span>
                        <span className={styles.c_amount}>{
                            amount
                        }</span>
                        <span className={styles.c_subfix}>
                            {helper.decodeHTML(amount === 1 ? l10n.textColor : l10n.colors)}
                        </span>
                    </span>
                </div>
            }
        </>
    );
}

function PfTileDetails(props: IPfTileDetails) {
    const {
        priceInformation,
        l10n,
        on_hover,
        colorVariantsAmount,
        description,
        priceMode,
        isMobile,
        isGlobal
    } = props;

    const getWithVatValue = React.useCallback(
        (priceModeCookie: string, priceModeFromLocalStorage): boolean => {
            let result;
            switch (priceModeCookie) {
                case 'Gross':
                    result = true;
                    break;
                case 'Net':
                    result = false;
                    break;
                default:
                    result =
                        typeof document !== 'undefined'
                            ? document.getElementsByClassName('current-pricemode-gross').length > 0
                            : priceModeFromLocalStorage == 'Gross';
            }
            return result;
        }, []);

    const withVat = React.useMemo(() => getWithVatValue(priceMode,
            typeof localStorage !== 'undefined' ? localStorage.getItem('PriceMode'): ''),
        [priceMode]);

    const getPriceString = React.useCallback((): string => {
        let numberStr: string;
        if (withVat && !isGlobal) {
            numberStr = priceInformation.priceGross;
        } else {
            numberStr = priceInformation.priceNet;
        }
        const result = priceInformation.prependCurrency
            ? `${priceInformation.currency} ${numberStr}`
            : `${numberStr} ${priceInformation.currency}`;

        return result;
    }, [priceInformation, withVat, isGlobal]);

    const minQuantity = React.useCallback((): number => {
        return priceInformation ? priceInformation.quantity : 0;
    }, [priceInformation]);

    const vatAcronym = withVat ? l10n.incVATAcronym : l10n.exVATAcronym;
    const vatString = !isGlobal ? `(${vatAcronym}) ` : '';
    const extraStringInternal = (minQuantity() > 1) ?
         `${vatString}${l10n.priceFromLocale} ${minQuantity()} ${l10n.items}` : `${vatString}`;
    const extraString =
        helper.decodeHTML(extraStringInternal);

    return (
        <div className={classNames(styles.t_details, styles.pf_result,
            { [styles.on_hover]: on_hover },
            { [styles.hidden]: on_hover })}>
            <div className={styles.d_title}>
                {description}
            </div>
            <div className={styles.d_bottom}>
                {isMobile &&
                    <div className={styles.d_p_extra}><VariantCount amount={colorVariantsAmount} l10n={l10n}/></div>}
                <div className={styles.d_price_container}>
                        <span className={classNames(styles.d_price)}>
                            <span>
                                {helper.decodeHTML(l10n.priceFromLocale)}&nbsp;
                            </span>
                            {!isGlobal ?
                                // TODO: ESPP-8858 - fix SSR price string missmatch
                                <span className='notranslate'>
                                    {getPriceString()}</span> : <span data-ge-price>{getPriceString()}
                                </span>
                            }
                        </span>
                </div>
                <div className={styles.d_p_extra}>
                    <span>{extraString}</span>
                    {!isMobile && <VariantCount amount={colorVariantsAmount} l10n={l10n}/>}
                </div>
            </div>
        </div>
    );
}

export default PfTileDetails;
